<template>
  <div>
    <b-button v-if="params.data.kabul == 0" variant="outline-light" v-on:click="approveReturn()" size="sm" style="padding: 0px;">
      <Icon icon="material-symbols:check" width="20" height="20" v-b-tooltip.hover.bottom="'ONAYLA'"
        color="#28C76F" />
    </b-button>

  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  components: {
    Icon
  },
  methods: {
    approveReturn() {
      this.$root.$emit("approveReturn", this.params.data);
    }
  }
};
</script>
